import * as React from "react";

import AppModals from "@editor/components/AppModals";
import { DebugModal } from "@editor/components/editor/debug/DebugPanel";
import Flows from "@editor/components/flows/Flows";
import useCurrentUser from "@editor/hooks/useCurrentUser";
import { useReploHotkeys } from "@editor/hooks/useHotkeys";
import { useEditorDispatch, useEditorSelector } from "@editor/store";
import {
  selectInternalDebugModeOn,
  setDebugPanelVisibility,
} from "@reducers/core-reducer";

import { ToastManager } from "@replo/design-system/components/alert/Toast";
import { Outlet } from "react-router-dom";

import DashboardSidebar from "./DashboardSidebar";

const DashboardLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const dispatch = useEditorDispatch();
  const isDebugPanelVisible = useEditorSelector(selectInternalDebugModeOn);
  const toggleDebugMode = React.useCallback(() => {
    dispatch(setDebugPanelVisibility(!isDebugPanelVisible));
  }, [dispatch, isDebugPanelVisible]);
  useReploHotkeys({ debug: toggleDebugMode });
  const { user } = useCurrentUser();

  return (
    <div className="flex h-screen flex-col">
      <ToastManager />
      <AppModals />
      {user && <Flows entityType="user" />}
      {isDebugPanelVisible && <DebugModal />}
      <div className="bg-sheet grid w-screen grow grid-cols-[1fr] no-scrollbar gap-x-4 p-3 overflow-y-scroll md:grid-cols-[fit-content(224px)_1fr]">
        <DashboardSidebar />
        <div className="no-scrollbar rounded-lg pb-0 overflow-y-scroll flex flex-col items-center h-full w-full">
          <div className="w-full overflow-y-scroll no-scrollbar flex flex-col items-center h-full">
            <Outlet />
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
